export const MembershipType = {
  SLOT: "slot",
  ADHOC: "adhoc",
  SESSIONAL: "sessional",
  PROSPECT: "prospect",
  WEEKEND: "weekend",
  SYSTEM: "system",
} as const;

export type MembershipType = (typeof MembershipType)[keyof typeof MembershipType];

export function membershipTypeForDisplay(type: MembershipType): { short: string; long: string } {
  if (!type) return { short: "", long: "" };
  switch (type) {
    case MembershipType.SLOT:
      return { short: "S", long: "Slot" };
    case MembershipType.ADHOC:
      return { short: "F", long: "Flexible" };
    case MembershipType.SESSIONAL:
      return { short: "X", long: "Sessional" };
    case MembershipType.PROSPECT:
      return { short: "P", long: "Prospect" };
    case MembershipType.WEEKEND:
      return { short: "W", long: "Weekend" };
    case MembershipType.SYSTEM:
      return { short: "Y", long: "System" };
    default:
      return { short: "", long: "" };
  }
}
